import {match} from 'ts-pattern';

import {VehicleFinancingTemplateType} from '@dms/api/sales';
import i18n from '@dms/i18n';

export function getTemplateTypeLabel(type: VehicleFinancingTemplateType) {
  return match(type)
    .with('STANDARD', () => i18n.t('entity.vehicleFinancingTemplate.type.standard'))
    .with('BALLOON', () => i18n.t('entity.vehicleFinancingTemplate.type.balloon'))
    .exhaustive();
}
